/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

// A wrapper class for YouTube and JWPlayer

export class VideoPlayer {
  type: "yt" | "jw";
  player: any;

  constructor(type: "yt" | "jw", player: any) {
    this.type = type;
    this.player = player;
  }

  play(): void {
    if (this.isPlaying()) this.pause();
    else this.type === "yt" ? this.player.playVideo() : this.player.play();
  }

  pause(): void {
    this.type === "yt" ? this.player.pauseVideo() : this.player.pause();
  }

  seek(num: number): void {
    this.type === "yt" ? this.player.seekTo(num) : this.player.seek(num);
  }

  getPosition(): number {
    return this.type === "yt"
      ? this.player.getCurrentTime()
      : this.player.getPosition();
  }

  getDuration(): number {
    return this.player.getDuration();
  }

  isPlaying(): boolean {
    return this.type === "yt"
      ? this.player.getPlayerState() === 1
      : this.player.getState() === "playing";
  }

  // isPaused(): boolean {
  //   return this.type === "yt"
  //     ? this.player.getPlayerState() === 2
  //     : this.player.getState() === "paused";
  // }
}
